import { useTranslation } from 'react-i18next'
import React from 'react'
import Button from '..//Button'
import Text from '../Text'

const ConfirmModal: React.FC<{
    text: string
    onSubmit: () => void
    onAbort?: () => void
}> = ({ text, onSubmit, onAbort }) => {
    const { t } = useTranslation(['common'])

    return (
        <div
            className={
                'zr-d-flex zr-items-center zr-justify-between zr-flex-column'
            }
            style={{ width: '350px' }}
        >
            <Text>{text}</Text>
            <Button
                hierarchy={'primary'}
                text={t('confirm')}
                fn={() => onSubmit()}
                classes={'zr-w-100 zr-mx-4 zr-my-2'}
            />
            <Button
                hierarchy={'secondary'}
                text={t('abort')}
                fn={() => onAbort?.()}
                classes={'zr-w-100 zr-mx-4 zr-my-2'}
            />
        </div>
    )
}

export default ConfirmModal
